(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jm-production-note"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-jm-shop-pay]');
  if (!button) return;
  const scope = button.closest('section') || button.closest('[id^="MainProduct-"]') || document;
  const terms = scope.querySelector('shopify-payment-terms');
  const action = terms?.shadowRoot?.querySelector('#shopify-installments-cta');
  if (action) {
    action.click();
  } else {
    const instructions = button.parentElement.querySelector('.jm-shop-pay-instructions');
    instructions.setAttribute('tabindex', '-1');
    instructions.focus();
  }
});
  } catch(e) { console.error(e); }
})();

})();
